export default {
      id: "message-usage",
      viewBox: "0 0 35 21",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#message",
      toString: function () {
        return this.url;
      }
    }